import logger from "../utils/logger";



export const dateFormat = (params, timeEnable = false) => {

    // logger.info('date param: ', params)

    const fecha = new Date(params);

    // logger.info('fecha completa: ', fecha)

    //👉 Obtener día, mes y año (últimos dos dígitos)
    const dia = String(fecha.getDate()).padStart(2, '0');
    const mes = String(fecha.getMonth() + 1).padStart(2, '0');
    const anio = String(fecha.getFullYear());

    const horas = String(fecha.getHours()).padStart(2, '0');
    const minutos = String(fecha.getMinutes()).padStart(2, '0');

    if(anio <= 1){
        return "-";
    }


    if (timeEnable) {
        const fechaYHora = `${dia}/${mes}/${anio} ${horas}:${minutos}`
        return fechaYHora

    } else {
        const fechaFormateada = `${dia}/${mes}/${anio}`;

        return fechaFormateada
    }


}